import React, { useCallback } from "react";
import { HubHookFormSelect } from "../../components";
import { BOX_GROUPS, BOX_TYPES } from "../../constants/boxing";
import { Chip, Stack, Typography } from "@mui/material";

export const BoxHubHookFormSelect = ({ customFilter, type, ...rest }) => {
  const filterFunction = useCallback(
    customFilter
      ? (o) => customFilter(o)
      : (o) => (type ? o.type === type : true),
    [customFilter, type],
  );

  const filtered =
    customFilter || type ? BOX_TYPES.filter(filterFunction) : BOX_TYPES;

  return (
    <HubHookFormSelect
      placeholder="Add Box"
      options={filtered}
      groupByKey="type"
      {...rest}
      renderValue={(value) => {
        const { label, type } = BOX_TYPES?.find(({ id }) => id === value);
        const { flow } = BOX_GROUPS?.find((t) => t.label === type);
        return (
          <Stack direction="row" gap="5px" alignItems="center">
            <Typography sx={{ fontSize: 10 }}>{label}</Typography>
            <Chip
              label={type}
              sx={{ fontSize: 10, height: "20px" }}
              variant="colorTag"
              flow={flow}
            />
          </Stack>
        );
      }}
    />
  );
};

export default BoxHubHookFormSelect;
